import { isMobile } from './tools'
(function flexible(window, document) {
  const docEl = document.documentElement
  let setRemTimer

  var viewport = document.getElementById('viewport')
  function adjustViewport() {
    // 如果clientWidth是980，说明视口可能被错误设置了
    if (document.documentElement.clientWidth === 980) {
        // 重新设置视口标签
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no')
    }
    setRemUnit()
  }
  function setBodyFontSize() {
      if (document.body) {
          document.body.style.fontSize = `${12 * (window.devicePixelRatio || 1)}px`
      } else {
          document.addEventListener('DOMContentLoaded', setBodyFontSize)
      }
  }

  function setRemUnit() {
      setBodyFontSize()
      const rem = isMobile() ? docEl.clientWidth / 5 : 75
      window.$rootFontSize = rem
      docEl.style.fontSize = `${rem}px`
  }

  setRemUnit()

  window.addEventListener('resize', () => {
      setRemTimer && clearTimeout(setRemTimer)
      setRemTimer = setTimeout(setRemUnit, 50)
  })
  window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        //   setRemUnit()
        adjustViewport()
      }
  })
}(window, document))
